

import { createSlice } from '@reduxjs/toolkit';


const defaultSettings = require('./defaultSettings');

const initialState = {
	data: defaultSettings,
	status: "dormant"
}

const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		setSettings: (state, action) => {
			// console.log("settings came in:", action.payload)
			state.data = action.payload;
			state.status = 'dormant';
		},

		// Sync the saved data after a successful save WITHOUT touching status,
		// so the "Changes saved" feedback animation is preserved.
		updateSettingsData: (state, action) => {
			state.data = action.payload;
		},
		  
		setSettingsStatus: (state, action) => {
			state.status = action.payload;
		}
	},
});

export const { setSettings, setSettingsStatus, updateSettingsData } = settingsSlice.actions;
export default settingsSlice.reducer;